// extracted by mini-css-extract-plugin
export default {"mainContainer":"Button_mainContainer__g6z7C","small":"Button_small__J4+uY","medium":"Button_medium__5JX+N","large":"Button_large__1oV+P"};